module.exports = __webpack_public_path__ + "img/product-hmr.ee6e76d8.png";